import axios from 'axios';
import { BASE_URL, DEFAULT_LANG } from './Constant';

const Axios = axios.create({
  baseURL: BASE_URL,
  withCredentials: true
});

Axios.interceptors.request.use(
  function (config) {
    // Set language header based on local storage or default value
    const lang = localStorage.getItem('lang');
    config.headers.lang = lang || DEFAULT_LANG;

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default Axios;
